<template>
  <div class="grid-y p-8 space-y-10 w-full settings-orders-mobile">
    <Loading class="cell" :loading="waitPending">
      <div class="flex flex-col items-start">
        <div class="flex flex-col space-y-12">
          <div
            class="flex flex-col items-start"
            v-if="payload">
            <b class="text-16px leading-18px title-divided mb-8">
              Длительности статусов заказа
            </b>
            <div class="flex flex-row items-start space-x-8">
              <Input
                label="Активный, ч."
                classes="bg-hint border-none"
                :inputmask="{
                alias: 'numeric',
                rightAlign: false,
                allowMinus: false,
                placeholder: '',
              }"
                v-model="payload.priority"
                :disabled="$wait.is('order.timers.update')"
                @keyup.enter.native="onEnter"
                @blur="onBlur"/>
              <Input
                label="Назначен, ч."
                classes="bg-hint border-none"
                :inputmask="{
                alias: 'numeric',
                rightAlign: false,
                allowMinus: false,
                placeholder: '',
              }"
                v-model="payload.startWork"
                :disabled="$wait.is('order.timers.update')"
                @keyup.enter.native="onEnter"
                @blur="onBlur"/>
              <Input
                label="В работе, ч."
                classes="bg-hint border-none"
                :inputmask="{
                alias: 'numeric',
                rightAlign: false,
                allowMinus: false,
                placeholder: '',
              }"
                v-model="payload.complete"
                :disabled="$wait.is('order.timers.update')"
                @keyup.enter.native="onEnter"
                @blur="onBlur"/>
              <Input
                label="Выполнен, ч."
                classes="bg-hint border-none"
                :inputmask="{
                alias: 'numeric',
                rightAlign: false,
                allowMinus: false,
                placeholder: '',
              }"
                v-model="payload.close"
                :disabled="$wait.is('order.timers.update')"
                @keyup.enter.native="onEnter"
                @blur="onBlur"/>
              <Input
                label="Спор, ч."
                classes="bg-hint border-none"
                :inputmask="{
                alias: 'numeric',
                rightAlign: false,
                allowMinus: false,
                placeholder: '',
              }"
                v-model="payload.dispute"
                :disabled="$wait.is('order.timers.update')"
                @keyup.enter.native="onEnter"
                @blur="onBlur"/>
            </div>
          </div>
          <div
            class="flex flex-col items-start space-y-8"
            v-if="configs">
            <b class="text-16px leading-18px title-divided">
              Настройки стоимостей заказов
            </b>
            <div class="flex flex-row items-stretch flex-wrap -mx-4 -my-4">
              <div class="px-4 py-4">
                <Input
                  label="Стоимость взятия заказа в руб."
                  class="w-72 h-full"
                  classes="bg-hint border-none"
                  :inputmask="{
                  alias: 'decimal',
                  rightAlign: false,
                  allowMinus: false,
                  placeholder: '',
                }"
                  v-model="localConfigs.orderAssignCost"
                  @keyup.enter.native="onConfigsEnter"
                  @blur="onConfigsBlur"/>
              </div>
              <div class="px-4 py-4">
                <Input
                  label="Стоимость сложной верификации в руб."
                  class="w-72 h-full"
                  classes="bg-hint border-none"
                  :inputmask="{
                  alias: 'decimal',
                  rightAlign: false,
                  allowMinus: false,
                  placeholder: '',
                }"
                  v-model="localConfigs.orderSubjectCryptAndSectionFillingSurcharge"
                  @keyup.enter.native="onConfigsEnter"
                  @blur="onConfigsBlur"/>
              </div>
              <div class="px-4 py-4">
                <Input
                  label="Стоимость простой верификации в руб."
                  class="w-72 h-full"
                  classes="bg-hint border-none"
                  :inputmask="{
                  alias: 'decimal',
                  rightAlign: false,
                  allowMinus: false,
                  placeholder: '',
                }"
                  v-model="localConfigs.orderSubjectVerificationSurcharge"
                  @keyup.enter.native="onConfigsEnter"
                  @blur="onConfigsBlur"/>
              </div>
            </div>
            <div class="flex flex-row items-stretch flex-wrap -mx-4 -my-4">
              <div class="px-4 py-4">
                <Input
                  label="Комиссия сервиса"
                  class="w-72 h-full"
                  classes="bg-hint border-none"
                  :inputmask="{
                  alias: 'decimal',
                  rightAlign: false,
                  allowMinus: false,
                  placeholder: '',
                }"
                  v-model="localConfigs.serviceCommission"
                  @keyup.enter.native="onConfigsEnter"
                  @blur="onConfigsBlur"/>
              </div>
              <div class="px-4 py-4">
                <Input
                  label="Комиссия сервиса для приоритетных заказов"
                  class="w-72 h-full"
                  classes="bg-hint border-none"
                  :inputmask="{
                  alias: 'decimal',
                  rightAlign: false,
                  allowMinus: false,
                  placeholder: '',
                }"
                  v-model="localConfigs.serviceCommissionPriority"
                  @keyup.enter.native="onConfigsEnter"
                  @blur="onConfigsBlur"/>
              </div>
            </div>
            <div class="flex flex-row items-stretch flex-wrap -mx-4 -my-4">
              <div class="px-4 py-4">
                <Input
                  label="Комиссия платежной системы в %"
                  class="w-72 h-full"
                  classes="bg-hint border-none"
                  :inputmask="{
                  alias: 'decimal',
                  rightAlign: false,
                  allowMinus: false,
                  placeholder: '',
                }"
                  v-model="localConfigs.paymentGatewayPercent"
                  @keyup.enter.native="onConfigsEnter"
                  @blur="onConfigsBlur"/>
              </div>
              <div class="px-4 py-4">
                <Input
                  label="Минимальная сумма комиссии платежной системы"
                  class="w-72 h-full"
                  classes="bg-hint border-none"
                  :inputmask="{
                  alias: 'decimal',
                  rightAlign: false,
                  allowMinus: false,
                  placeholder: '',
                }"
                  v-model="localConfigs.paymentGatewayMinAmount"
                  @keyup.enter.native="onConfigsEnter"
                  @blur="onConfigsBlur"/>
              </div>
              <div class="px-4 py-4">
                <Input
                  label="Стоимость транзакции"
                  class="w-72 h-full"
                  classes="bg-hint border-none"
                  :inputmask="{
                  alias: 'decimal',
                  rightAlign: false,
                  allowMinus: false,
                  placeholder: '',
                }"
                  v-model="localConfigs.paymentGatewayTransactionCost"
                  @keyup.enter.native="onConfigsEnter"
                  @blur="onConfigsBlur"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loading>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import Input from '@/components/Input.vue';
import Loading from '@/components/Loading.vue';

export default {
  components: {
    Input,
    Loading,
  },
  data() {
    return {
      payload: null,
      localConfigs: null,
    };
  },
  computed: {
    ...mapState({
      timers: (state) => state.settings.orderTimers,
      configs: (state) => state.settings.configs,
    }),
    waitPending() {
      return this.$wait.is('fetch.configs');
    },
  },
  watch: {
    timers: {
      handler(value) {
        this.payload = value;
      },
      immediate: true,
    },
    configs: {
      handler(value) {
        this.localConfigs = value;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      update: 'settings/ACT_UPDATE_ORDER_TIMERS',
      fetchConfigs: 'settings/ACT_FETCH_CONFIGS',
      updateConfigs: 'settings/ACT_UPDATE_CONFIGS',
    }),
    onEnter(event) {
      event.target.blur();
    },
    onConfigsEnter(event) {
      event.target.blur();
    },
    onBlur() {
      const data = _.mapValues(this.payload, (value) => parseInt(value, 10));
      this.update(data);
    },
    onConfigsBlur() {
      const data = _.mapValues(this.localConfigs, (value) => value);
      this.updateConfigs(data);
    },
  },
  mounted() {
    this.fetchConfigs();
  },
};
</script>
